import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, } from 'rxjs/operators';
import { Router } from '@angular/router';
import { EnvService } from '../services/env.service';



//const AUTH_API  = `${GetUrlAPI.getURL}login`; 
 //const AUTH_API  = "http://localhost:3000"; 

const httpOptions= {headers: new HttpHeaders({'Content-Type':'application/json'}) };

@Injectable({
  providedIn: 'root'
})



export class AuthService {

   loggedUserName : string;
   controlPermissionArray = [];

  constructor(private http: HttpClient,private router: Router,private env: EnvService) { }

  login(userLoginData): Observable<any> {
    return this.http.post(`${this.env.apiUrl}/login`,userLoginData, httpOptions)
    .pipe(catchError(this.handleError));
   
  }

  loggedIn(){
    return !!localStorage.getItem('token')
  }
  

  getUserData(){
    return {
      username: sessionStorage.getItem('username'),
      passowrd :sessionStorage.getItem('password'),
    }
  }

  isStoredData(){
    return {
      username: !!sessionStorage.getItem('username'),
      passowrd :!!sessionStorage.getItem('password'),
    }
  }
  
  getToken(){
    return localStorage.getItem('token')
  }

  getUserLoggedIn(){
    return sessionStorage.getItem('username')
  }

  logoutUser(){
    localStorage.removeItem('token');
    this.router.navigate(['/login']);
  }

  private handleError(errorResponse: HttpErrorResponse) {
    return throwError(errorResponse || "Server Error");
    }



}
